import picsioConfig from '../../../../../config';
import { getOptionDefaultValue } from '../../components/DownloadDialog/config';
import { isFullImageCrop } from './cropToNormalized';
import { isBulkCopyCropAspect } from './copyCropAspectPresets';

const { isMainApp } = picsioConfig;

/**
 * Builds the payload passed to getZipUrls / download flow (legacy DownloadDialog.handleSubmit + crop).
 */
export default function buildDownloadSubmitConfig({
  selectedPreset,
  isAssetsWithWatermark,
  subscriptionFeatures,
  normalizedCrop,
  cropAspectPreset,
  duplicateSelectionCount,
  copyPreviewAssetId,
}) {
  const isWatermarkingAllowed = subscriptionFeatures.watermarks;
  const { _id, data } = selectedPreset;
  const {
    mimeType,
    quality,
    density,
    units,
    resizing,
    width,
    height,
    isArchive,
    organizeByCollections,
    withoutWatermark,
    resolution,
    usePdfProxy,
  } = data;
  const isOriginalPreset = _id === 'original';
  const isDefaultFormat = mimeType === 'original';
  const isOriginal = isMainApp ? isOriginalPreset && isDefaultFormat : isDefaultFormat;
  const displayWatermark = isWatermarkingAllowed || !isMainApp;

  const config = {
    mimeType,
    organizeByCollections,
    isArchive,
    withoutWatermark: displayWatermark ? withoutWatermark : true,
    resolution,
    usePdfProxy,
  };

  if (!isOriginal) {
    config.quality = quality;
    config.resizing = resizing;
    config.density = null;

    if (density !== getOptionDefaultValue('density')) {
      config.density = density;
      config.units = units;
    }
    if (resizing !== getOptionDefaultValue('resizing')) {
      config.width = Number(width);
      if (Number.isFinite(Number(height))) {
        config.height = Number(height);
      }
    }
  }
  if (isAssetsWithWatermark) {
    config.ignoreCache = true;
  }

  // Zipper download pipeline only invokes the Converter (and therefore precrop)
  // when mimeType is not 'original'. Strip crop silently in that edge case so
  // the request shape stays consistent and cache keys don't drift.
  const canApplyCrop = !isOriginal;

  const bulkCropAspect = canApplyCrop
    && duplicateSelectionCount > 1
    && !copyPreviewAssetId
    && isBulkCopyCropAspect(cropAspectPreset)
    ? cropAspectPreset
    : null;
  if (bulkCropAspect) {
    config.cropAspect = bulkCropAspect;
  }

  if (canApplyCrop && normalizedCrop && !isFullImageCrop(normalizedCrop)) {
    config.crop = {
      x1: normalizedCrop.x1,
      y1: normalizedCrop.y1,
      x2: normalizedCrop.x2,
      y2: normalizedCrop.y2,
    };
  }

  // Single-asset download of a default social preset (chips ratio picked, no
  // normalized rect from preview): still pass the aspect so zipper performs a
  // centered crop server-side.
  if (canApplyCrop && !config.crop && !config.cropAspect && isBulkCopyCropAspect(cropAspectPreset)) {
    config.cropAspect = cropAspectPreset;
  }

  return config;
}
